import React from 'react'

interface SubtitleProps {
  subtitle: string
}
const Subtitle: React.FC<SubtitleProps> = (props: SubtitleProps) => {
  return <h2 className="subtitle container mb-0">{props.subtitle}</h2>
}

export default Subtitle
